var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 250,
    viewBox: "0 0 233 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8_752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.519 88H98.3388C92.9163 88 88.5242 92.3674 88.5242 97.7592V151.42C88.5242 156.812 92.9163 161.179 98.3388 161.179H135.13C140.553 161.179 144.945 156.812 144.945 151.42V110.299C144.945 107.712 143.909 105.229 142.072 103.397L129.461 90.857C127.618 89.0245 125.121 88 122.519 88Z",
    fill: "url(#paint0_linear_8_752)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.285 88H96.1043C90.6818 88 86.2897 92.3674 86.2897 97.7592V151.42C86.2897 156.812 90.6818 161.179 96.1043 161.179H132.896C138.318 161.179 142.71 156.812 142.71 151.42V110.299C142.71 107.712 141.674 105.229 139.837 103.397L127.226 90.857C125.383 89.0245 122.887 88 120.285 88Z",
    fill: "url(#paint1_linear_8_752)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8_752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.526 129.873V125.166C119.526 121.919 116.877 119.283 113.613 119.283H79.9124C76.6488 119.283 74 121.919 74 125.166V166.95C74 171.168 77.4351 174.586 81.6743 174.586H147.326C151.565 174.586 155 171.168 155 166.95V137.509C155 133.291 151.565 129.873 147.326 129.873H119.526Z",
    fill: "url(#paint2_linear_8_752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.526 129.873V130.873H119.526H147.326C151.017 130.873 154 133.848 154 137.509V166.95C154 170.611 151.017 173.586 147.326 173.586H81.6743C77.9827 173.586 75 170.611 75 166.95V125.166C75 122.475 77.1964 120.283 79.9124 120.283H113.613C116.329 120.283 118.526 122.475 118.526 125.166V129.873Z",
    stroke: "url(#paint3_linear_8_752)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_752",
    x: 0.52417,
    y: 0.0000305176,
    width: 232.421,
    height: 249.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44,
    result: "effect1_foregroundBlur_8_752"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8_752",
    x: 56,
    y: 101.283,
    width: 117,
    height: 91.3034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8_752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8_752",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_752",
    x1: 90.4141,
    y1: 93.4153,
    x2: 136.637,
    y2: 159.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78D1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_752",
    x1: 88.1796,
    y1: 93.4153,
    x2: 134.403,
    y2: 159.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78D1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_752",
    x1: 78.5729,
    y1: 171.464,
    x2: 124.264,
    y2: 104.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_752",
    x1: 79.7177,
    y1: 123.632,
    x2: 121.75,
    y2: 189.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.1849342330ba3600ccf3dc9f22beb550.svg";
export { ForwardRef as ReactComponent };